import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ButtonStyle, ButtonType } from './button-type';
/**
 * Button component.
 */
var ButtonComponent = /** @class */ (function () {
    /**
     * The default constructor
     */
    function ButtonComponent() {
        /**
         * Indicates button should automatically get focus when the page loads
         */
        this.autofocus = false;
        /**
         * The disabled state
         */
        this.disabled = false;
        /**
         * Specifies that the form-data should not be validated on submission. Only for type submit
         */
        this.formNoValidate = false;
        /**
         * The button style
         *
         * See [[ButtonStyle]]
         */
        this.style = ButtonStyle.DEFAULT;
        /**
         * The button type
         *
         * See [[ButtonType]]
         */
        this.type = ButtonType.BUTTON;
        /**
         * The event emitted when a button has been clicked
         */
        this.onClick = new EventEmitter();
    }
    // Initialization
    /**
     * Setup component configuration upon initialization
     */
    ButtonComponent.prototype.ngOnInit = function () {
    };
    // Actions
    ButtonComponent.prototype.handleClick = function ($event) {
        this.onClick.emit({
            eventName: 'onClick',
            id: this.id,
            name: this.name,
            value: this.value
        });
    };
    ButtonComponent.decorators = [
        { type: Component, args: [{
                    encapsulation: ViewEncapsulation.None,
                    selector: 'pfng-button',
                    template: "<button class=\"pf-c-button\" [attr.form]=\"form\" [attr.formaction]=\"formAction\" [attr.formenctype]=\"formEncType\" [attr.formmethod]=\"formMethod\" [attr.formnovalidate]=\"formNoValidate\" [attr.formtarget]=\"formTarget\" [autofocus]=\"autofocus\" [disabled]=\"disabled\" [id]=\"id\" [name]=\"name\" [ngClass]=\"{\n          'pf-m-danger': style === 'danger',\n          'pf-m-primary': style === 'primary',\n          'pf-m-secondary': style === 'secondary',\n          'pf-m-tertiary': style === 'tertiary',\n          'pf-m-link': style === 'link',\n          'pf-m-action': style === 'action',\n          'pf-m-disabled': style === 'disabled'\n        }\" [title]=\"tooltip\" [type]=\"type\" [value]=\"value\" (click)=\"handleClick($event)\"><ng-content></ng-content></button>"
                },] },
    ];
    /** @nocollapse */
    ButtonComponent.ctorParameters = function () { return []; };
    ButtonComponent.propDecorators = {
        'autofocus': [{ type: Input },],
        'disabled': [{ type: Input },],
        'form': [{ type: Input },],
        'formAction': [{ type: Input },],
        'formEncType': [{ type: Input },],
        'formMethod': [{ type: Input },],
        'formNoValidate': [{ type: Input },],
        'formTarget': [{ type: Input },],
        'id': [{ type: Input },],
        'name': [{ type: Input },],
        'style': [{ type: Input },],
        'tooltip': [{ type: Input },],
        'type': [{ type: Input },],
        'value': [{ type: Input },],
        'onClick': [{ type: Output, args: ['onClick',] },],
    };
    return ButtonComponent;
}());
export { ButtonComponent };
//# sourceMappingURL=button.component.js.map